import styled from "@emotion/styled";
import {
  useContext,
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import ImageThumb from "./ImageThumb";
import { UploadCloud } from "react-feather";

// import { ScreenPropsContext } from "../../context/ScreenPropsContext";

const FormImage = forwardRef((props, ref) => {
  // const screenProps = useContext(ScreenPropsContext);
  const { input, config, dataHelper } = props;
  const [images, setImages] = useState([]);
  const fileRef = useRef(null);

  // const { popup } = screenProps;

  useImperativeHandle(ref, () => ({
    reset() {
      setImages([]);
    },
  }));

  useEffect(() => {
    input.setValue(JSON.stringify(images));
  }, [images]);

  const onImageChange = async (ev) => {
    //input.setLoading(true);

    const file = ev.target.files[0];
    const reader = new FileReader();

    if (file) {
      reader.readAsDataURL(file);
    }

    reader.onloadend = () => {
      if (ev.target.files && ev.target.files[0]) {
        let img = ev.target.files[0]; // <-- upload

        let aImages = [...images];
        let maxImages = input?.inputOptions?.maxImages || 1;

        if (aImages.length >= maxImages) {
          aImages.shift();
        }

        const fileName = ev.target.files[0].name;
        const base64Image = reader.result;
        const imageBlob = URL.createObjectURL(img);
        const imageId = input.inputOptions.imageIdGenerator();
        const path = input.inputOptions.path;

        setImages([
          ...aImages,
          {
            loading: false,
            imageBlob,
            path,
            imageId,
            base64Image,
            fileName,
          },
        ]);

        fileRef.current.value = null;
      }
    };

    input.setLoading(false);
  };

  const labelClick = (ev) => {
    ev.stopPropagation();
    fileRef.current.click();
  };

  const openImageRemovalConfirmation = (e, image) => {
  //   popup.setContent(
  //     <StyledConfirmationModal config={config}>
  //       <div className={"popup-title"}>
  //         <h3>{props.config.strings.form.label.CONFIRM_ATTACHMENT_REMOVAL}</h3>
  //       </div>
  //       <div className={"popup-content"}>
  //         <p>
  //           {props.config.strings.form.message.CONFIRM_ATTACHMENT_REMOVAL_MESSAGE.replace(
  //             "%name%",
  //             image.fileName
  //           )}
  //         </p>
  //       </div>
  //       <div className={"popup-buttons"}>
  //         <button
  //           className={"button-style"}
  //           widthValue={"80px"}
  //           config={config}
  //           onClick={(ev) => removeImage(e, image)}
  //           size="large"
  //         >
  //           {"Sim"}
  //         </button>
  //         <div
  //           className={"cancel-button"}
  //           onClick={(e) => popup.setIsOpen(false)}
  //         >
  //           <p>{props.config.strings.form.label.CANCEL}</p>
  //         </div>
  //       </div>
  //     </StyledConfirmationModal>
  //   );
  //   popup.setIsOpen(true);
  };

  const removeImage = (e, image) => {
    //openImageRemovalConfirmation(e, image);
    e.stopPropagation();
    setImages((a) => a.filter((i) => i !== image));
    // popup.setIsOpen(false);
  };

  const reset = () => {};

  if (input?.layout === "holder") {
    return (
      <StyledFormImageHolder config={config} onClick={labelClick}>
        <input
          type={"hidden"}
          id={props.id || "formimage" + Math.floor(Math.random() * 10000)}
          ref={input?.inputRef}
        />
        <input
          ref={fileRef}
          className={"file-input"}
          type="file"
          name="myImage"
          accept="image/*"
          onChange={onImageChange}
        />
        {images?.length ? (
          <div className={"image"}>
            <ImageThumb
              type={"background"}
              key={images[0].imageId}
              config={config}
              imageUrl={images[0].imageUrl}
              thumbUrl={images[0].imageBlob}
              loading={images[0].loading}
              removeImage={(e) => removeImage(e, images[0])}
            />
          </div>
        ) : (
          <></>
        )}
        <div className={"holder-place"}>
          <p className={"label"}>{input.label}</p>
          <UploadCloud />
        </div>
        <span typo="caption-md" className="error">
          {input?.error}
        </span>
      </StyledFormImageHolder>
    );
  }

  return (
    <StyledFormImage config={config}>
      <input
        type={"hidden"}
        id={props.id || "formimage" + Math.floor(Math.random() * 10000)}
        ref={input?.inputRef}
      />
      <a className={"label"} onClick={labelClick}>
        <i className={"fa fa-paperclip"} /> {input.label}{" "}
        <i class="fa fa-arrow-right" />
      </a>
      <div className={"sub-label"}>
        <p>{props.config.strings.form.label.CAN_IMPORT_MORE_IMAGES}</p>
      </div>
      <input
        ref={fileRef}
        className={"file-input"}
        type="file"
        name="myImage"
        accept="image/*"
        onChange={onImageChange}
      />
      <div className={"images"}>
        {images?.map((image) => (
          <ImageThumb
            key={image.imageId}
            config={config}
            imageUrl={image.imageUrl}
            thumbUrl={image.imageBlob}
            loading={image.loading}
            fileName={image.fileName}
            removeImage={(e) => openImageRemovalConfirmation(e, image)}
          />
        ))}
      </div>
      <span typo="caption-md" className="error">
        {input?.error}
      </span>
    </StyledFormImage>
  );
});

export default FormImage;

const StyledConfirmationModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: rgba(0, 59, 33, 1);
  max-width: 420px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;

  .popup-content {
    text-align: left;
    font-family: "Sarabun";
    font-size: 16px;
  }

  .button-style {
  }

  .button-style span {
    font-weight: 700;
    font-size: 18px;
  }

  .popup-title {
    width: 100%;
    text-align: left;
    font-family: TekturNarrow;
    text-transform: uppercase;
    font-size: 21px;
    font-weight: 600;
  }

  .popup-buttons {
    padding-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;

    span > div {
      font-weight: 700;
      font-size: 18px;
    }
  }

  .cancel-button {
    margin-left: 27px;
    cursor: pointer;
  }

  .cancel-button p {
    font-weight: bold;
    font-size: 12px;
    font-weight: 600;
    font-family: TekturNarrow;
    text-transform: uppercase;
  }
`;

const StyledFormImageHolder = styled.a`
  position: relative;
  border: 2px dashed #999;
  border-radius: 10px;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .file-input {
    position: absolute;
    bottom: -30px;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .holder-place {
    display: flex;
    padding: 20px;
    background-color: white;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;

    .label {
      display: inline-block;
      text-align: center;
      font-size: 0.8em;

      > p {
        margin-bottom: 10px;
      }
    }
  }

  .image + .holder-place {
    display: none;

    &:hover {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      opacity: 0.9;
    }
  }

  .image:hover + .holder-place {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    opacity: 0.9;
  }

  .image {
    width: 100%;
    height: 100%;
  }

  .error {
    position: absolute;
    color: red;
    font-size: 0.7em;
    bottom: -16px;
    left: 0;
  }
`;

const StyledFormImage = styled.div`
  .label {
    color: ${(props) => props.config.colors.BRAND.BASE};
    cursor: pointer;
    font-family: TekturNarrow;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 20px;

    &.mobile {
      font-size: 18px;
      line-height: 22.5px;
      font-weight: 700;
    }
  }

  .sub-label {
    font-size: 14px;
    margin-top: 10px;
    font-family: "Sarabun";
    color: ${(props) => props.config.colors.BRAND.DARK};
  }

  .file-input {
    position: absolute;
    bottom: -30px;
    opacity: 0;
    width: 0;
    height: 0;
  }

  .images {
    display: flex;
    flex-direction: column;
    margin: 30px 0;
  }
`;
